const deliveryOptions = [
  {value: 'Delivered', label: 'Delivered'},
  {value: 'Express', label: 'Express'},
  {value: 'LocalPickUp', label: 'Local Pickup'},
] as const;

export default deliveryOptions;
